module.exports = __webpack_public_path__ + "img/ko_number_01.300f4031.svg";